<template>
  <div class="list-view">
    <div class="list-view-content">
      <div class="list-operte">
        <div class="filter">
          <el-row :gutter="8">
            <el-col :span="6">
              <el-input clearable class="filter-input" size="small" v-model="searchName" placeholder="搜索留言内容"></el-input>
            </el-col>
            <el-col :span="6">
              <el-button class="filter-btns" type="warning" size="small"  @click="search(1)">查 询</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="list">
        <el-table ref="table" stripe :data="list"  style="width: 100%" height="100%" 
          header-cell-class-name="table-header" border v-if="list.length > 0"
          cell-class-name="table-cell" highlight-current-row>
          <el-table-column label="序号" type="index" width="70"></el-table-column>
          <el-table-column label="微信昵称" prop="name"></el-table-column>
          <el-table-column label="内容" prop="content"></el-table-column>
          <el-table-column label="联系电话" prop="phone"></el-table-column>
          <el-table-column width="350" label="操作">
            <template v-slot="scope">
              <div class="list-opert-warp">
                <span class="list-opert-btn delete" @click="doDelete(scope.row)">删除</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="none" v-else >
          <img src="@/assets/image/zw.png"/>
        </div>
      </div>
      <el-pagination class="pagination" background layout="total, sizes, prev, pager, next, jumper" @size-change="changeSize" :page-sizes="pageSizeList" @current-change="changePage" :current-page="pageNum" :page-size="pageSize" :total="totalNum"></el-pagination>
    </div>
  </div>
</template>
<script>
import professionalApi from '@/api/professional'
export default {
  name: 'record',
  data () {
    return {
      list: [],
      pageSize: 10,
      pageNum: 1,
      totalNum: 0,
      formVisible: false,
      searchName: '',
      rowId: ''
    }
  },
  methods: {
    doDelete (row) {
      this.$confirm('是否确认删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        professionalApi.leaveMessageDel({
          rowIds: row.rowId
        }).then(res => {
          this.$message.success('删除成功！')
          this.search()
        })
      }).catch(() => { })
    },
    search (page = 1) {
      this.pageNum = page
      professionalApi.leaveMessageList({
        page: {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        },
        params: {
          content: this.searchName
        }
      }).then(res => {
        this.list = res.items
        this.totalNum = res.total
      })
    },
    changePage (page) {
      this.search(page)
    },
    changeSize (size) {
      this.pageSize = size
      this.search(1)
    }
  },
  created () {
    this.search(1)
  }
}
</script>

<style lang="less" scoped>
</style>